import { BedIcon } from '@jouzen/ecom-components/icons/BedIcon';
import { HeartIcon } from '@jouzen/ecom-components/icons/HeartIcon';
import { HrvIcon } from '@jouzen/ecom-components/icons/HrvIcon';
import { LungsIcon } from '@jouzen/ecom-components/icons/LungsIcon';
import { TargetIcon } from '@jouzen/ecom-components/icons/TargetIcon';
import { TitaniumIcon } from '@jouzen/ecom-components/icons/TitaniumIcon';
import { TrendsIcon } from '@jouzen/ecom-components/icons/TrendsIcon';
import { InverseHeader } from '@jouzen/ecom-components/layout';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import DescriptionItem from './DescriptionItem';

const HeartHealthLinkTitle = () => {
  const t = useTranslations();

  return (
    <Link href="https://support.ouraring.com/hc/articles/360025588793-Resting-Heart-Rate">
      {t('heart_rate_monitoring_heart_rate_title')}
    </Link>
  );
};

const OxygenLinkTitle = () => {
  const t = useTranslations();

  return (
    <Link href="https://support.ouraring.com/hc/articles/7328398760851-Blood-Oxygen-Sensing-SpO2-">
      {t('pdp_horizon_spo2_title')}
    </Link>
  );
};

const FsaDescription = () => {
  const t = useTranslations();

  return (
    <InverseHeader enter>
      <section className="bg-sandstone-500 pt-20 pb-10 lg:pt-24 lg:pb-14">
        <LayoutGrid className="gap-y-0">
          <Typography
            Element="h2"
            variant="h4"
            color="light"
            className="col-main mb-10 lg:col-end-8"
          >
            {t('pdp_horizon_description_title')}
          </Typography>

          <Typography
            Element="ul"
            color="light"
            className="col-main lg:col-span-7 lg:col-start-9 lg:row-start-1"
          >
            <DescriptionItem icon={HrvIcon} title={<HeartHealthLinkTitle />}>
              {t('heart_rate_monitoring_heart_rate_description')}
            </DescriptionItem>

            <DescriptionItem icon={LungsIcon} title={<OxygenLinkTitle />}>
              {t('heart_rate_monitoring_spo2_description')}
            </DescriptionItem>

            <DescriptionItem
              icon={TargetIcon}
              title={t('heart_rate_monitoring_accuracy_title')}
            >
              {t('heart_rate_monitoring_accuracy_description')}
            </DescriptionItem>

            <DescriptionItem
              icon={BedIcon}
              title={t('heart_rate_monitoring_hrv_title')}
            >
              {t('heart_rate_monitoring_hrv_description')}
            </DescriptionItem>
          </Typography>

          <Typography
            Element="ul"
            color="light"
            className="col-main lg:col-span-7 lg:col-start-17 lg:row-start-1"
          >
            <DescriptionItem
              icon={HeartIcon}
              title={t('heart_rate_monitoring_health_stats_title')}
            >
              {t('heart_rate_monitoring_health_stats_description')}
            </DescriptionItem>

            <DescriptionItem
              icon={TitaniumIcon}
              title={t('pdp_highlights_titanium')}
            >
              {t('heart_rate_monitoring_titanium_description')}
            </DescriptionItem>

            <DescriptionItem icon={TrendsIcon} title={t('trends')}>
              {t('heart_rate_monitoring_trends_description')}
            </DescriptionItem>
          </Typography>
        </LayoutGrid>
      </section>
    </InverseHeader>
  );
};

export default FsaDescription;
